class ProjectListingFilter {
  constructor(component) {
    this.refs = {
      toggle: '.js-project-listing-filter-dropdown-toggle',
      list: '.js-project-listing-filter-list',
      filterButtons: '.js-project-listing-filter-button',
    };

    this.dom = {
      $toggle: document.querySelector(this.refs.toggle),
      $list: document.querySelector(this.refs.list),
      $filterButtons: document.querySelectorAll(this.refs.filterButtons),
    };

    this.state = {
    }

    this.onToggle = this.onToggle.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.calculateHeight = this.calculateHeight.bind(this);

    this.init();
  }

  init() {
    const { dom } = this;

    this.calculateHeight();
    if (dom.$toggle) {
      dom.$toggle.addEventListener('click', this.onToggle);
    }

    if (dom.$filterButtons) {
      dom.$filterButtons.forEach(btn => {
        btn.addEventListener('click', this.closeDropdown);
      });
    }
  }

  onToggle() {
    const { dom } = this;

    const isOpen = dom.$list.classList.toggle('is-open');
    dom.$toggle.setAttribute('aria-expanded', isOpen);
  }

  closeDropdown() {
    const { dom } = this;

    dom.$list.classList.remove('is-open');
    dom.$toggle.setAttribute('aria-expanded', false);
  }

  calculateHeight() {
    const { dom } = this;

    const items = Array.from(dom.$list.children);

    // Get the gap dynamically
    const style = window.getComputedStyle(dom.$list);
    const gap = 20;

    // Container padding
    const paddingTop = 30;
    const paddingBottom = 30;

    // Total height: sum of children + gaps + padding
    const totalHeight =
      items.reduce((sum, item) => sum + item.offsetHeight, 0) +
      gap * (items.length - 1) +
      paddingTop +
      paddingBottom;

    dom.$list.style.setProperty('--max-height', `${totalHeight}px`);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const $projectListingFilter = document.querySelector('.js-project-listing-filter');
  if (!$projectListingFilter) return;
  new ProjectListingFilter($projectListingFilter);
});
